import {Component, OnInit} from '@angular/core';
import {TotalServiceReportDetail} from '../../../model/TotalServiceReportDetail';
import {Router} from '@angular/router';
import {Constant} from '../../../../global/util/Constant';
import {SignatureReportService} from '../../../service/signature-report.service';
import {TotalServiceReport} from '../../../model/TotalServiceReport';
import {Month} from '../../../../global/util/Month';

@Component({
  selector: 'app-services-report-detail',
  templateUrl: './services-report-detail.component.html',
  styleUrls: ['./services-report-detail.component.css']
})
export class ServicesReportDetailComponent implements OnInit {
  public totalServiceReportDetails: TotalServiceReportDetail[] = [];
  public totalServiceReport: TotalServiceReport;
  public loading: boolean;
  public partnerId: number;
  public enterpriseId: number;
  public workflowId: number;
  public dateStart: string;
  public dateEnd: string;

  constructor(private router: Router,
              private signatureReportService: SignatureReportService) {
  }

  ngOnInit(): void {
    this.totalServiceReportDetails = history.state.totalServiceReportDetail;
    this.partnerId = history.state.partnerId;
    this.enterpriseId = history.state.enterpriseId;
    this.workflowId = history.state.workflowId;
    this.dateStart = history.state.dateStart;
    this.dateEnd = history.state.dateEnd;
    this.totalServiceReport = history.state.totalServiceReport;
  }

  goBack(): void {
    this.router.navigate(['service-report']).then(); // Reemplaza '/ruta-anterior' con la ruta a la que quieras regresar
  }

  public downloadReport() {
    const url = Constant.ROOT_API_V1.concat('/totalReportServiceDetail/search/report?',
      'partnerId=', String(this.partnerId),
      '&enterpriseId=', String(this.enterpriseId),
      '&workflowId=', String(this.workflowId),
      '&dateFrom=', this.dateStart,
      '&dateTo=', this.dateEnd,
      '&level=', String(this.totalServiceReport.level),
      '&hasTSA=', String(this.totalServiceReport.tsa),
      '&typeSignature=', String(this.totalServiceReport.id));
    this.loading = true;
    this.signatureReportService.getReportOf(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = 'Reporte de detalle servicios';
      control.click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  getMonth(monthNumber: any) {
    switch (monthNumber) {
      case Month.January:
        return 'Enero';
      case Month.February:
        return 'Febrero';
      case Month.March:
        return 'Marzo';
      case Month.April:
        return 'Abril';
      case Month.May:
        return 'Mayo';
      case Month.June:
        return 'Junio';
      case Month.July:
        return 'Julio';
      case Month.August:
        return 'Agosto';
      case Month.September:
        return 'Setiembre';
      case Month.October:
        return 'Octubre';
      case Month.November:
        return 'Noviembre';
      case Month.December:
        return 'Diciembre';
    }

  }

}
